module.exports = __webpack_public_path__ + "assets/img/iot_server.bd007672.png";